module.exports = __webpack_public_path__ + "img/google-play-badge.7bf5d76e.png";